const website = localStorage.getItem("website");
export const getVideoPagePayload = (videoConfigruation) => {
  const website = localStorage.getItem("website");
  const toHexStringIfNotAlready = (color) => {
    if (typeof color === "string" && color.startsWith("#")) {
      return color;
    } else {
      return color?.toHexString?.();
    }
  };
  let video_page = {
    layout: videoConfigruation?.layout,
    is_video_mute: videoConfigruation?.is_video_mute,
    pip_screen: {
      display: videoConfigruation?.pip_screen?.display,
      location: videoConfigruation?.pip_screen?.location,
    },
    email_embed: {
      display: videoConfigruation?.email_embed?.display,
      location: "top-right",
    },
    smv: {
      type: videoConfigruation?.smv?.type,
      display: videoConfigruation?.smv?.display,
      share: {
        display: videoConfigruation?.smv?.showShare,
      },
      mute: {
        display: videoConfigruation?.smv?.showMute,
      },
      view: {
        display: videoConfigruation?.smv?.showView,
        icon: videoConfigruation?.smv?.view_icon,
      },
      like: {
        display: videoConfigruation?.smv?.like,
      },
    },

    discount: {
      display: videoConfigruation?.discount?.display,
      text: videoConfigruation?.discount?.text,
      style: {
        bg_color: toHexStringIfNotAlready(
          videoConfigruation?.discount?.style?.bg_color
        ),
        font_color: toHexStringIfNotAlready(
          videoConfigruation?.discount?.style?.font_color
        ),
        font_weight: videoConfigruation?.discount?.style?.font_weight,
      },
    },

    actionable:
      website == "others"
        ? {
            atc: {
              display: videoConfigruation?.actionable?.atc?.display,
              name: videoConfigruation?.actionable?.atc?.name,
              style: {
                font_color: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc?.style?.font_color
                ),
                font_style:
                  videoConfigruation?.actionable?.atc?.style?.font_style,
                bg_color: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc?.style?.bg_color
                ),
                font_weight:
                  videoConfigruation?.actionable?.atc?.style?.font_weight,
                borderRadius:
                  videoConfigruation?.actionable?.atc_shopify?.style
                    ?.borderRadius,
                border: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc_shopify?.style?.border
                ),
              },
              event: "pdp",
              action_type: "button",
            },
          }
        : {
            atc_shopify: {
              display: videoConfigruation?.actionable?.atc_shopify?.display,
              name: videoConfigruation?.actionable?.atc_shopify?.name,
              style: {
                font_color: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc_shopify?.style?.font_color
                ),
                font_style:
                  videoConfigruation?.actionable?.atc_shopify?.style
                    ?.font_style,
                bg_color: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc_shopify?.style?.bg_color
                ),
                font_weight:
                  videoConfigruation?.actionable?.atc_shopify?.style
                    ?.font_weight,
                borderRadius:
                  videoConfigruation?.actionable?.atc_shopify?.style
                    ?.borderRadius,
                border: toHexStringIfNotAlready(
                  videoConfigruation?.actionable?.atc_shopify?.style?.border
                ),
              },
              event: videoConfigruation?.actionable?.atc_shopify?.event,
              action_type: "button",
              layout: videoConfigruation?.actionable?.atc_shopify?.layout,
              actionable: {
                checkout: {
                  display:
                    videoConfigruation?.actionable?.atc_shopify?.actionable
                      ?.checkout?.display,
                  action_type: "button",
                  event: "checkout",
                  name: videoConfigruation?.actionable?.atc_shopify?.actionable
                    ?.checkout?.name,
                  style: {
                    font_color: toHexStringIfNotAlready(
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.font_color
                    ),
                    font_style:
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.font_style,
                    bg_color: toHexStringIfNotAlready(
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.bg_color
                    ),
                    font_weight:
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.font_weight,
                    borderRadius:
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.borderRadius,
                    border: toHexStringIfNotAlready(
                      videoConfigruation?.actionable?.atc_shopify?.actionable
                        ?.checkout?.style?.border
                    ),
                  },
                },
                shopping:
                  videoConfigruation?.actionable?.atc_shopify?.layout ==
                  "checkout"
                    ? null
                    : {
                        display:
                          videoConfigruation?.actionable?.atc_shopify
                            ?.actionable?.shopping?.display,
                        action_type: "button",
                        event: "shopping",
                        name: videoConfigruation?.actionable?.atc_shopify
                          ?.actionable?.shopping?.name,
                        style: {
                          font_color: toHexStringIfNotAlready(
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.font_color
                          ),
                          font_style:
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.font_style,
                          bg_color: toHexStringIfNotAlready(
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.bg_color
                          ),
                          font_weight:
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.font_weight,
                          borderRadius:
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.borderRadius,
                          border: toHexStringIfNotAlready(
                            videoConfigruation?.actionable?.atc_shopify
                              ?.actionable?.shopping?.style?.border
                          ),
                        },
                      },
              },
            },
          },

    product: {
      display: videoConfigruation?.product?.display,
      type: videoConfigruation?.product?.type,
      style: {
        bg_color: toHexStringIfNotAlready(
          videoConfigruation?.product?.style?.bg_color
        ),
      },
      image: {
        display: videoConfigruation?.product?.image?.display,
        type: videoConfigruation?.product?.image?.type,
        style: {
          height:
            String(videoConfigruation?.product?.image?.style?.height) + "px",
          width:
            String(videoConfigruation?.product?.image?.style?.height) + "px",
        },
      },
      name: {
        display: videoConfigruation?.product?.name?.display,
        style: {
          font_color: toHexStringIfNotAlready(
            videoConfigruation?.product?.name?.style?.font_color
          ),
          font_style: videoConfigruation?.product?.name?.style?.font_style,
          font_weight: videoConfigruation?.product?.name?.style?.font_weight,
        },
      },
      more_info: {
        display: videoConfigruation?.product?.more_info?.display,
        event: "pdp",
      },
      price: {
        display: videoConfigruation?.product?.price?.display,
        text: videoConfigruation?.product?.price?.symbolText,
        format: videoConfigruation?.product?.price?.format,
        prefix: videoConfigruation?.product?.price?.prefix,

        original: {
          display: videoConfigruation?.product?.price?.original?.display,
          style: {
            font_color: toHexStringIfNotAlready(
              videoConfigruation?.product?.price?.original?.style?.font_color
            ),
            font_style:
              videoConfigruation?.product?.price?.original?.style?.font_style,
            font_weight:
              videoConfigruation?.product?.price?.original?.style?.font_weight,
          },
        },
        offer: {
          display: videoConfigruation?.product?.price?.offer?.display,
          style: {
            font_color: toHexStringIfNotAlready(
              videoConfigruation?.product?.price?.offer?.style?.font_color
            ),
            font_style:
              videoConfigruation?.product?.price?.offer?.style?.font_style,
            font_weight:
              videoConfigruation?.product?.price?.offer?.style?.font_weight,
          },
        },
        discount: {
          display: videoConfigruation?.product?.price?.discount?.display,
          style: {
            font_color: toHexStringIfNotAlready(
              videoConfigruation?.product?.price?.discount?.style?.font_color
            ),
            font_style:
              videoConfigruation?.product?.price?.discount?.style?.font_style,
            font_weight:
              videoConfigruation?.product?.price?.discount?.style?.font_weight,
          },
        },
      },
    },

    atc: {
      primary: {
        text: videoConfigruation?.atc?.primary?.name,
        style: {
          font_weight: videoConfigruation?.atc?.primary?.style?.font_weight,
          font_color: toHexStringIfNotAlready(
            videoConfigruation?.atc?.primary?.style?.font_color
          ),
          bg_color: toHexStringIfNotAlready(
            videoConfigruation?.atc?.primary?.style?.bg_color
          ),
          borderRadius: videoConfigruation?.atc?.primary?.style?.borderRadius,
          border: toHexStringIfNotAlready(
            videoConfigruation?.atc?.primary?.style?.border
          ),
        },
      },
      secondary: {
        text: videoConfigruation?.atc?.secondary?.name,
        style: {
          font_weight: videoConfigruation?.atc?.secondary?.style?.font_weight,
          font_color: toHexStringIfNotAlready(
            videoConfigruation?.atc?.secondary?.style?.font_color
          ),
          bg_color: toHexStringIfNotAlready(
            videoConfigruation?.atc?.secondary?.style?.bg_color
          ),
          borderRadius: videoConfigruation?.atc?.secondary?.style?.borderRadius,
          border: toHexStringIfNotAlready(
            videoConfigruation?.atc?.secondary?.style?.border
          ),
        },
      },
    },

    glass_theme: videoConfigruation?.glass_theme,
    glass_theme_atc: {
      primary: {
        text: videoConfigruation?.glass_theme_atc?.primary?.text,
        style: {
          font_color: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.primary?.style?.font_color
          ),
          bg_color: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.primary?.style?.bg_color
          ),
          font_weight:
            videoConfigruation?.glass_theme_atc?.primary?.style?.font_weight,
          borderRadius:
            videoConfigruation?.glass_theme_atc?.primary?.style?.borderRadius,
          border: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.primary?.style?.border
          ),
        },
      },
      secondary: {
        text: videoConfigruation?.glass_theme_atc?.secondary?.text,
        style: {
          font_color: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.secondary?.style?.font_color
          ),
          bg_color: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.secondary?.style?.bg_color
          ),
          font_weight:
            videoConfigruation?.glass_theme_atc?.secondary?.style?.font_weight,
          borderRadius:
            videoConfigruation?.glass_theme_atc?.secondary?.style?.borderRadius,
          border: toHexStringIfNotAlready(
            videoConfigruation?.glass_theme_atc?.secondary?.style?.border
          ),
        },
      },
    },
    checkout_cta: {
      text: videoConfigruation?.checkout_cta?.text,
      style: {
        font_color: toHexStringIfNotAlready(
          videoConfigruation?.checkout_cta?.style?.font_color
        ),
        bg_color: toHexStringIfNotAlready(
          videoConfigruation?.checkout_cta?.style?.bg_color
        ),
        font_weight: videoConfigruation?.checkout_cta?.style?.font_weight,
        borderRadius: videoConfigruation?.checkout_cta?.style?.borderRadius,
        border: toHexStringIfNotAlready(
          videoConfigruation?.checkout_cta?.style?.border
        ),
      },
    },
    vudio_branding: {
      display: videoConfigruation?.vudio_branding?.display,
      style:{
        placement: videoConfigruation?.vudio_branding?.style?.placement
      }
   },

    cart_icon: videoConfigruation?.cart_icon,
    tags:{
      display: videoConfigruation?.tags?.display,
     }
  };
  return video_page;
};

export const video_configuration = {
  layout: "1",
  pip_screen: {
    display: true,
    location: "right",
  },
  email_embed: {
    display: true,
    location: "top-right",
  },
  is_video_mute: true,
  smv: {
    type: "smv1",
    display: true,
    showView: true,
    showShare: true,
    showMute: false,
    view_icon: "1",
    like: true,
  },

  discount: {
    display: true,
    style: {
      bg_color: "#ECD4D4",
      font_color: "#000000",
      font_weight: "400",
    },
    text: "discount",
  },

  actionable: {
    atc_shopify: {
      display: true,
      name: "Buy Now",
      style: {
        font_color: "#000000",
        font_style: "bold",
        bg_color: "#ECD4D4",
        font_weight: "400",
        borderRadius: "6px",
        border: "none",
      },
      event: "atc",
      action_type: "button",
      layout: "checkout-shopping",
      actionable: {
        checkout: {
          display: true,
          action_type: "button",
          event: "checkout",
          name: "Add To Cart",
          style: {
            font_color: "#000000",
            font_style: "bold",
            bg_color: "#ECD4D4",
            font_weight: "400",
            borderRadius: "6px",
            border: "none",
          },
        },
        shopping: {
          display: true,
          action_type: "button",
          event: "checkout",
          name: "Add To Cart",
          style: {
            font_color: "#000000",
            font_style: "bold",
            bg_color: "#ECD4D4",
            font_weight: "400",
            borderRadius: "6px",
            border: "none",
          },
        },
      },
    },
    atc: {
      display: true,
      name: "Buy Now",
      style: {
        font_color: "#000000",
        font_style: "bold",
        bg_color: "#ECD4D4",
        font_weight: "400",
      },
      event: "pdp",
      action_type: "button",
    },
  },

  product: {
    display: true,
    type: "single",
    product_layout: {
      layout_size: "L",
    },
    style: {
      bg_color: "#ECD4D4",
    },
    image: {
      display: true,
      type: "circle",
      style: {
        height: 32,
      },
    },
    name: {
      display: true,
      style: {
        font_color: "#000000",
        font_style: "normal",
        font_weight: "400",
      },
    },
    more_info: {
      display: true,
      event: "pdp",
    },
    price: {
      display: true,
      format: "integer",
      symbolText: "",
      prefix: true,
      original: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
      offer: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
      discount: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
    },
  },

  atc: {
    primary: {
      name: "Add To Cart",
      style: {
        font_weight: "400",
        font_color: "#000",
        bg_color: "#fff",
        borderRadius: "6px",
        border: "none",
      },
    },
    secondary: {
      name: "More Info",
      style: {
        font_weight: "400",
        font_color: "#000",
        bg_color: "#fff",
        borderRadius: "6px",
        border: "none",
      },
    },
  },

  glass_theme: false,

  glass_theme_atc: {
    primary: {
      text: "Add To Cart",
      style: {
        font_color: "#000000",
        font_weight: "400",
        bg_color: "#ffffff",
        borderRadius: "6px",
        border: "none",
      },
    },
    secondary: {
      text: "Buy Now",
      style: {
        font_color: "#000000",
        font_weight: "400",
        bg_color: "#ffffff",
        borderRadius: "6px",
        border: "none",
      },
    },
  },

  checkout_cta: {
    text: "Buy Now",
    style: {
      font_color: "#ffffff",
      bg_color: "#000000",
      font_weight: 500,
      borderRadius: "6px",
      border: "none",
    },
  },
  vudio_branding: {
    display: false,
    style: {
      placement: "center",
    },
  },
  cart_icon: true,
};

export const home_configuration = {
  layout: "actionable",
  background: {
    display: false,
    background_image: null,
  },
  actionable: {
    redirect: {
      action_type: "button",
      display: true,
      style: {
        font_color: "#000000",
        bg_color: "#ECD4D4",
        font_style: "normal",
        font_weight: "400",
        borderRadius: "6px",
        border: "none",
      },
      text: "Buy Now",
      event: "pdp",
    },
  },
  header: {
    display: true,
    text: "Watch and Shop",
    style: {
      font_color: "#000000",
      font_style: "normal",
      font_weight: "400",
      font_size: "23px",
    },
  },
  views: {
    display: true,
    icon: "1",
    style: {
      placement: "bottom-left",
    },
  },
  discount: {
    display: true,
    style: {
      bg_color: "#ECD4D4",
      font_color: "#000000",
      placement: "top-left",
      font_weight: "400",
    },
    text: "discount",
  },
  mute_unmute: {
    display: true,
  },
  play_pause: {
    display: true,
  },

  product: {
    display: true,
    type: "single",
    layout: "flex-column",
    placement: "attached",
    image: {
      display: true,
      type: "circle",
    },
    name: {
      display: true,
      style: {
        font_color: "#000000",
        font_style: "normal",
        font_weight: "400",
      },
    },
    description: {
      display: true,
      style: {
        font_color: "#000000",
        font_style: "normal",
        font_weight: "400",
      },
    },
    price: {
      display: true,
      symbolText: "",
      format: "integer",
      prefix: true,
      original: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
      offer: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
      discount: {
        display: true,
        style: {
          font_color: "#000000",
          font_style: "normal",
          font_weight: "400",
        },
      },
    },
  },
  name_card: {
    display: false,
    type: "ATTACHED",
    name_type: "FEED_NAME",
    style: {
      font_color: "#000000",
      font_style: "normal",
      font_weight: "600",
    },
  },
  pdp_configuration: {
    style:{
    height: 460,
    width: 234,
    font_size: 20,
    font_weight: 400,
    name_card_height: "4vh",
    }, 
    show_branding: true,
    show_sf_name: true,
  },
  layout_configuration: {
    showMobileArrow: true,
    showDesktopArrow: true,
    cardHeight: 440,
    cardWidth: 240,
    cardMobileHeight: 340,
    cardMobileWidth: 200,
  },
  auto_play: false,

  collage_theme_home_page: {
    display_image: true,
    video_play_mode: "hover",
    section_height: 200,
  },
  vudio_branding: {
    display: false,
    style:{
      placement: "center"
    }
  },
  like: true,
  share: true,
  home_feed_card_styles: {
    card_shadow: true,
    card_border_radius: "8px",
  },
  home_feed_autoplay: {
    desktop: "two_cards",
    mobile: "two_cards",
  },
  view_more_sf_cta:{
    display: true,
    text: "View More",
    style: {
      font_color: "#000000",
      bg_color: "#ECD4D4",
      font_style: "normal",
      font_weight: "400",
    },
  },
  tabs_config:{
    font_color: "#000000"
  },
  tags:{
    display: false,
   }  
};

export const handleHomePageConfiguration = (data) => {
  let homepageData = data?.home_page;
  let homepage_configuration = {
    homepageActionable: homepageData?.actionable?.redirect,
    homepageHeader: homepageData?.header,
    homepageViews: homepageData?.views,
    homepageDiscount: homepageData?.discount,
    homepageProduct: homepageData?.product,
    homepagePrice: homepageData?.product?.price,
    homePageCardSize: homepageData?.home_feed_video_card_size,
    mobileSizeArrow: data?.mobile_configuration?.show_arrow,
    desktopSizeArrow: homepageData?.slider_arrow,
    homepageBackground: homepageData?.home_page_background,
    homePageNameCard: homepageData?.name_card,
    homepageprimaryATC: homepageData?.atc?.primary,
    homepageSecondaryATC: homepageData?.atc?.secondary,
    homePageCollageTheme: homepageData?.collage_theme_home_page,
    homePageVudioBranding: homepageData?.vudio_branding,
    homePageCardStyle: homepageData?.home_feed_card_styles,
    homePageAutoplay: homepageData?.home_feed_autoplay,
    homePageLike: homepageData?.like,
    homePageShare: homepageData?.share,
    homePageViewMoreSFCTA: homepageData?.view_more_sf_cta,
    homePageTabsConfig: homepageData?.tabs_config
  };
  const homepagConfiguration = {
    layout: data?.layout,
    background: {
      display:
        homepage_configuration?.homepageBackground?.display != null
          ? homepage_configuration?.homepageBackground?.display
          : false,
      background_image:
        homepage_configuration?.homepageBackground?.background_image,
    },
    auto_play:
      homepageData?.auto_play != null ? homepageData?.auto_play : false,
    actionable: {
      redirect: {
        action_type:
          homepage_configuration?.homepageActionable?.action_type || "button",
        display:
          homepage_configuration?.homepageActionable?.display != null
            ? homepage_configuration?.homepageActionable?.display
            : false,
        style: {
          font_color:
            homepage_configuration?.homepageActionable?.style?.font_color ||
            "#000000",
          bg_color:
            homepage_configuration?.homepageActionable?.style?.bg_color ||
            "#ECD4D4",
          font_style: homepage_configuration?.homepageActionable?.style
            ?.font_style
            ? homepage_configuration?.homepageActionable?.style?.font_style.includes(
                "italic"
              )
              ? "italic"
              : homepage_configuration?.homepageActionable?.style?.font_style
            : "normal",
          font_weight: homepage_configuration?.homepageActionable?.style
            ?.font_weight
            ? homepage_configuration?.homepageActionable?.style?.font_weight
            : "400",
          borderRadius: homepage_configuration?.homepageActionable?.style
            ?.borderRadius
            ? homepage_configuration?.homepageActionable?.style?.borderRadius
            : "6px",
          border: homepage_configuration?.homepageActionable?.style?.border
            ? homepage_configuration?.homepageActionable?.style?.border
            : "none",
        },
        text: homepage_configuration?.homepageActionable?.text || "Buy Now",
        event: homepage_configuration?.homepageActionable?.event || "pdp",
      },
    },
    header: {
      display:
        homepage_configuration?.homepageHeader?.display != null
          ? homepage_configuration?.homepageHeader?.display
          : true,
      text: homepage_configuration?.homepageHeader?.text || "Watch and Shop",
      style: {
        font_color: homepage_configuration?.homepageHeader?.style?.font_color
          ? homepage_configuration?.homepageHeader?.style?.font_color
          : "#000000",
        font_style: homepage_configuration?.homepageHeader?.style?.font_style
          ? homepage_configuration?.homepageHeader?.style?.font_style.includes(
              "italic"
            )
            ? "italic"
            : homepage_configuration?.homepageHeader?.style?.font_style
          : "normal",
        font_weight: homepage_configuration?.homepageHeader?.style?.font_weight
          ? homepage_configuration?.homepageHeader?.style?.font_weight
          : "400",
        font_size: homepage_configuration?.homepageHeader?.style?.font_size
          ? homepage_configuration?.homepageHeader?.style?.font_size
          : "23px",
      },
    },
    views: {
      display:
        homepage_configuration?.homepageViews?.display != null
          ? homepage_configuration?.homepageViews?.display
          : true,
      icon: homepage_configuration?.homepageViews?.icon
        ? homepage_configuration?.homepageViews?.icon == "1"
          ? "1"
          : "2"
        : "1",
      style: {
        placement:
          homepage_configuration?.homepageViews?.style?.placement ||
          "bottom-left",
        bg_color:
          homepage_configuration?.homepageViews?.style?.bg_color ||
          "rgba(255, 255, 255, 0.2)",
      },
    },
    discount: {
      display:
        homepage_configuration?.homepageDiscount?.display != null
          ? homepage_configuration?.homepageDiscount?.display
          : true,
      style: {
        bg_color:
          homepage_configuration?.homepageDiscount?.style?.bg_color ||
          "#ECD4D4",
        font_color:
          homepage_configuration?.homepageDiscount?.style?.font_color ||
          "#000000",
        placement:
          homepage_configuration?.homepageDiscount?.style?.placement ||
          "top-left",
        font_weight: homepage_configuration?.homepageDiscount?.style
          ?.font_weight
          ? homepage_configuration?.homepageDiscount?.style?.font_weight
          : "400",
      },
      text: homepage_configuration?.homepageDiscount?.text || "discount",
    },
    mute_unmute: {
      display: homepageData?.mute_unmute?.display,
    },
    play_pause: {
      display: homepageData?.play_pause?.display,
    },
    product: {
      display:
        homepage_configuration?.homepageProduct?.display != null
          ? homepage_configuration?.homepageProduct?.display
          : false,
      type: homepage_configuration?.homepageProduct?.type || "single",
      layout: homepage_configuration?.homepageProduct?.layout || "flex-column",
      placement:
        homepage_configuration?.homepageProduct?.placement || "attached",
      image: {
        display:
          homepage_configuration?.homepageProduct?.image?.display != null
            ? homepage_configuration?.homepageProduct?.image?.display
            : true,
        type: homepage_configuration?.homepageProduct?.image?.type || "circle",
        style: {
          height: homepage_configuration?.homepageProduct?.image?.style?.height
            ? Number(
                homepage_configuration?.homepageProduct?.image?.style?.height.replace(
                  "px",
                  ""
                )
              )
            : 32,
        },
      },
      name: {
        display: true,
        style: {
          font_color: homepage_configuration?.homepageProduct?.name?.style
            ?.font_color
            ? homepage_configuration?.homepageProduct?.name?.style?.font_color
            : "#000000",
          font_style: homepage_configuration?.homepageProduct?.name?.style
            ?.font_style
            ? homepage_configuration?.homepageProduct?.name?.style?.font_style.includes(
                "italic"
              )
              ? "italic"
              : homepage_configuration?.homepageProduct?.name?.style?.font_style
            : "normal",
          font_weight: homepage_configuration?.homepageProduct?.name?.style
            ?.font_weight
            ? homepage_configuration?.homepageProduct?.name?.style?.font_weight
            : "400",
        },
      },
      description: {
        display:
          homepage_configuration?.homepageProduct?.description?.display != null
            ? homepage_configuration?.homepageProduct?.description?.display
            : false,
        style: {
          font_color:
            homepage_configuration?.homepageProduct?.description?.style
              ?.font_color || "#000000",
          font_style: homepage_configuration?.homepageProduct?.description
            ?.style?.font_style
            ? homepage_configuration?.homepageProduct?.description?.style?.font_style.includes(
                "italic"
              )
              ? "italic"
              : homepage_configuration?.homepageProduct?.description?.style
                  ?.font_style
            : "normal",
          font_weight: homepage_configuration?.homepageProduct?.description
            ?.style?.font_weight
            ? homepage_configuration?.homepageProduct?.description?.style
                ?.font_weight
            : "400",
        },
      },
      price: {
        display:
          homepage_configuration?.homepagePrice?.display != null
            ? homepage_configuration?.homepagePrice?.display
            : true,
        symbolText: homepage_configuration?.homepagePrice?.text || "INR",
        format: homepage_configuration?.homepagePrice?.format || "integer",
        prefix:
          homepage_configuration?.homepagePrice?.prefix != null
            ? homepage_configuration?.homepagePrice?.prefix
            : true,
        original: {
          display:
            homepage_configuration?.homepagePrice?.original?.display != null
              ? homepage_configuration?.homepagePrice?.original?.display
              : true,
          style: {
            font_color:
              homepage_configuration?.homepagePrice?.original?.style
                ?.font_color || "#000000",
            font_style: homepage_configuration?.homepagePrice?.original?.style
              ?.font_style
              ? homepage_configuration?.homepagePrice?.original?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : homepage_configuration?.homepagePrice?.original?.style
                    ?.font_style
              : "normal",
            font_weight: homepage_configuration?.homepagePrice?.original?.style
              ?.font_weight
              ? homepage_configuration?.homepagePrice?.original?.style
                  ?.font_weight
              : "400",
          },
        },
        offer: {
          display:
            homepage_configuration?.homepagePrice?.offer?.display != null
              ? homepage_configuration?.homepagePrice?.offer?.display
              : true,
          style: {
            font_color:
              homepage_configuration?.homepagePrice?.offer?.style?.font_color ||
              "#000000",
            font_style: homepage_configuration?.homepagePrice?.offer?.style
              ?.font_style
              ? homepage_configuration?.homepagePrice?.offer?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : homepage_configuration?.homepagePrice?.offer?.style
                    ?.font_style
              : "normal",
            font_weight: homepage_configuration?.homepagePrice?.offer?.style
              ?.font_weight
              ? homepage_configuration?.homepagePrice?.offer?.style?.font_weight
              : "400",
          },
        },
        discount: {
          display:
            homepage_configuration?.homepagePrice?.discount?.display != null
              ? homepage_configuration?.homepagePrice?.discount?.display
              : true,
          style: {
            font_color:
              homepage_configuration?.homepagePrice?.discount?.style
                ?.font_color || "#000000",
            font_style: homepage_configuration?.homepagePrice?.discount?.style
              ?.font_style
              ? homepage_configuration?.homepagePrice?.discount?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : homepage_configuration?.homepagePrice?.discount?.style
                    ?.font_style
              : "normal",
            font_weight: homepage_configuration?.homepagePrice?.discount?.style
              ?.font_weight
              ? homepage_configuration?.homepagePrice?.discount?.style
                  ?.font_weight
              : "400",
          },
        },
      },
    },
    name_card: {
      display: homepage_configuration?.homePageNameCard?.display || false,
      type: homepage_configuration?.homePageNameCard?.type || "ATTACHED",
      name_type:
        homepage_configuration?.homePageNameCard?.name_type || "FEED_NAME",
      style: {
        font_color:
          homepage_configuration?.homePageNameCard?.style?.font_color ||
          "#000000",
        font_style:
          homepage_configuration?.homePageNameCard?.style?.font_style ||
          "normal",
        font_weight:
          homepage_configuration?.homePageNameCard?.style?.font_weight || "600",
      },
    },
    pdp_configuration: {
      style:{
      height:
        data?.pdp_configuration?.style?.height == "inherit"
          ? 460
          : Number(data?.pdp_configuration?.style?.height.replace("px", "")),
      width: data?.pdp_configuration?.style?.width
        ? Number(data?.pdp_configuration?.style?.width.replace("px", ""))
        : 234,
      font_size: data?.pdp_configuration?.style?.font_size
        ? Number(data?.pdp_configuration?.style?.font_size.replace("px", ""))
        : 20,
      font_weight: data?.pdp_configuration?.style?.font_weight
        ? data?.pdp_configuration?.style?.font_weight
        : 400,
      },
      show_branding:
        data.pdp_configuration?.show_branding == true
          ? data.pdp_configuration?.show_branding
          : false,
      show_sf_name:
        data.pdp_configuration?.show_sf_name == true
          ? data.pdp_configuration?.show_sf_name
          : false,
    },
    layout_configuration: {
      showMobileArrow:
        homepage_configuration?.mobileSizeArrow != null
          ? homepage_configuration?.mobileSizeArrow
          : true,
      showDesktopArrow:
        homepage_configuration?.desktopSizeArrow != null
          ? homepage_configuration?.desktopSizeArrow
          : true,
      cardHeight: homepage_configuration?.homePageCardSize?.height
        ? Number(
            homepage_configuration?.homePageCardSize?.height?.replace("px", "")
          )
        : 440,
      cardWidth: homepage_configuration?.homePageCardSize?.width
        ? Number(
            homepage_configuration?.homePageCardSize?.width?.replace("px", "")
          )
        : 240,
      cardMobileHeight: homepage_configuration?.homePageCardSize
        ?.mobile_view_card_height
        ? Number(
            homepage_configuration?.homePageCardSize?.mobile_view_card_height?.replace(
              "px",
              ""
            )
          )
        : 340,
      cardMobileWidth: homepage_configuration?.homePageCardSize
        ?.mobile_view_card_width
        ? Number(
            homepage_configuration?.homePageCardSize?.mobile_view_card_width?.replace(
              "px",
              ""
            )
          )
        : 200,
    },
    atc: {
      primary: {
        text: homepage_configuration?.homepageprimaryATC?.text
          ? homepage_configuration?.homepageprimaryATC?.text
          : "Add To Cart",
        style: {
          font_color: homepage_configuration?.homepageprimaryATC?.style
            ?.font_color
            ? homepage_configuration?.homepageprimaryATC?.style?.font_color
            : "#000000",
          font_weight: homepage_configuration?.homepageprimaryATC?.style
            ?.font_weight
            ? homepage_configuration?.homepageprimaryATC?.style?.font_weight
            : "400",
          bg_color: homepage_configuration?.homepageprimaryATC?.style?.bg_color
            ? homepage_configuration?.homepageprimaryATC?.style?.bg_color
            : "#ffffff",
          borderRadius: homepage_configuration?.homepageprimaryATC?.style
            ?.borderRadius
            ? homepage_configuration?.homepageprimaryATC?.style?.borderRadius
            : "6px",
          border: homepage_configuration?.homepageprimaryATC?.style?.border
            ? homepage_configuration?.homepageprimaryATC?.style?.border
            : "none",
        },
      },
      secondary: {
        text: homepage_configuration?.homepageSecondaryATC?.text
          ? homepage_configuration?.homepageSecondaryATC?.text
          : "Add To Cart",
        style: {
          font_color: homepage_configuration?.homepageSecondaryATC?.style
            ?.font_color
            ? homepage_configuration?.homepageSecondaryATC?.style?.font_color
            : "#000000",
          font_weight: homepage_configuration?.homepageSecondaryATC?.style
            ?.font_weight
            ? homepage_configuration?.homepageSecondaryATC?.style?.font_weight
            : "400",
          bg_color: homepage_configuration?.homepageSecondaryATC?.style
            ?.bg_color
            ? homepage_configuration?.homepageSecondaryATC?.style?.bg_color
            : "#ffffff",
          borderRadius: homepage_configuration?.homepageSecondaryATC?.style
            ?.borderRadius
            ? homepage_configuration?.homepageSecondaryATC?.style?.borderRadius
            : "6px",
          border: homepage_configuration?.homepageSecondaryATC?.style?.border
            ? homepage_configuration?.homepageSecondaryATC?.style?.border
            : "none",
        },
      },
    },
    collage_theme_home_page: {
      display_image:
        homepage_configuration?.homePageCollageTheme?.display_image,
      video_play_mode:
        homepage_configuration?.homePageCollageTheme?.video_play_mode,
      section_height: Number(
        homepage_configuration?.homePageCollageTheme?.section_height?.replace(
          "px",
          ""
        )
      ),
    },
    vudio_branding: {
      display: homepage_configuration?.homePageVudioBranding?.display,
      style:{
        placement: homepage_configuration?.homePageVudioBranding?.style?.placement
      }
   },
    like: homepage_configuration?.homePageLike,
    share: homepage_configuration?.homePageShare,
    home_feed_card_styles: {
      card_shadow:
        homepage_configuration?.homePageCardStyle?.card_shadow,
      card_border_radius:
        homepage_configuration?.homePageCardStyle?.card_border_radius,
    },

    home_feed_autoplay: {
      desktop: homepage_configuration?.homePageAutoplay?.desktop,
      mobile: homepage_configuration?.homePageAutoplay?.mobile,
    },
    view_more_sf_cta:{
    display: homepage_configuration?.homePageViewMoreSFCTA?.display,
    text:  homepage_configuration?.homePageViewMoreSFCTA?.text,
    style: {
      font_color:  homepage_configuration?.homePageViewMoreSFCTA?.style?.font_color,
      bg_color: homepage_configuration?.homePageViewMoreSFCTA?.style?.bg_color,
      font_style: homepage_configuration?.homePageViewMoreSFCTA?.style?.font_style,
      font_weight: homepage_configuration?.homePageViewMoreSFCTA?.style?.font_weight,
    },    
  },
    tabs_config:{
    font_color:  homepage_configuration?.homePageTabsConfig?.font_color
  }    
  };
  return homepagConfiguration;
};

export const handleVideoPageConfiguration = (data) => {
  let videoPageData = data?.video_page;
  let videopage_configuration = {
    videopageSMV: videoPageData?.smv,
    videopageDiscount: videoPageData?.discount,
    videopageActionableShopify: videoPageData?.actionable?.atc_shopify,
    videopageActionableNonShopify: videoPageData?.actionable?.atc,
    videopageProduct: videoPageData?.product,
    videopagePrice: videoPageData?.product?.price,
    videopagePrimaryATC: videoPageData?.atc?.primary,
    videopageSecondryATC: videoPageData?.atc?.secondary,
    videPagePrimaryGlassATC: videoPageData?.glass_theme_atc?.primary,
    videPageSecondaryGlassATC: videoPageData?.glass_theme_atc?.secondary,
    productLayoutSize: data?.layout_size,
    videoPageCheckoutCTA: videoPageData?.checkout_cta,
    videoPageVudioBranding: videoPageData?.vudio_branding,
  };
  const videConfigruation = {
    layout: videoPageData?.layout ? videoPageData?.layout : "1",
    is_video_mute:
      videoPageData?.is_video_mute != null
        ? videoPageData?.is_video_mute
        : true,
    pip_screen: {
      display:
        videoPageData?.pip_screen?.display != null
          ? videoPageData?.pip_screen?.display
          : true,
      location:
        data?.pip_configuration?.pip_placement != null
          ? data?.pip_configuration?.pip_placement
          : "right",
    },
    email_embed: {
      display:
        videoPageData?.email_embed?.display != null
          ? videoPageData?.email_embed?.display
          : true,
      location: "top-left",
    },
    smv: {
      type: videopage_configuration?.videopageSMV?.type || "smv1",
      display:
        videopage_configuration?.videopageSMV?.display != null
          ? videopage_configuration?.videopageSMV?.display
          : true,
      showShare:
        videopage_configuration?.videopageSMV?.share?.display != null
          ? videopage_configuration?.videopageSMV?.share?.display
          : true,
      showMute:
        videopage_configuration?.videopageSMV?.mute?.display != null
          ? videopage_configuration?.videopageSMV?.mute?.display
          : true,
      showView:
        videopage_configuration?.videopageSMV?.view?.display != null
          ? videopage_configuration?.videopageSMV?.view?.display
          : true,
      view_icon:
        videopage_configuration?.videopageSMV?.view?.icon != null
          ? videopage_configuration?.videopageSMV?.view?.icon
          : "1",
      like:
        videopage_configuration?.videopageSMV?.like?.display != null
          ? videopage_configuration?.videopageSMV?.like?.display
          : true,
    },
    discount: {
      display:
        videopage_configuration?.videopageDiscount?.display != null
          ? videopage_configuration?.videopageDiscount?.display
          : true,
      style: {
        bg_color: videopage_configuration?.videopageDiscount?.style?.bg_color
          ? videopage_configuration?.videopageDiscount?.style?.bg_color
          : "#FFFFFF",
        font_color: videopage_configuration?.videopageDiscount?.style
          ?.font_color
          ? videopage_configuration?.videopageDiscount?.style?.font_color
          : "#000000",
        font_weight: videopage_configuration?.videopageDiscount?.style
          ?.font_weight
          ? videopage_configuration?.videopageDiscount?.style?.font_weight
          : "400",
      },
      text: videopage_configuration?.videopageDiscount?.text
        ? videopage_configuration?.videopageDiscount?.text
        : "discount",
    },
    actionable:
      website != "others"
        ? {
            atc_shopify: {
              display:
                videopage_configuration?.videopageActionableShopify?.display !=
                null
                  ? videopage_configuration?.videopageActionableShopify?.display
                  : true,
              name:
                videopage_configuration?.videopageActionableShopify?.name ||
                "Buy Now",
              style: {
                font_color:
                  videopage_configuration?.videopageActionableShopify?.style
                    ?.font_color || "#000000",
                font_style: videopage_configuration?.videopageActionableShopify
                  ?.style?.font_style
                  ? videopage_configuration?.videopageActionableShopify?.style?.font_style.includes(
                      "italic"
                    )
                    ? "italic"
                    : videopage_configuration?.videopageActionableShopify?.style
                        ?.font_style
                  : "normal",
                bg_color:
                  videopage_configuration?.videopageActionableShopify?.style
                    ?.bg_color || "#ECD4D4",
                font_weight: videopage_configuration?.videopageActionableShopify
                  ?.style?.font_weight
                  ? videopage_configuration?.videopageActionableShopify?.style
                      ?.font_weight
                  : "400",
                borderRadius: videopage_configuration
                  ?.videopageActionableShopify?.style?.borderRadius
                  ? videopage_configuration?.videopageActionableShopify?.style
                      ?.borderRadius
                  : "6px",
                border: videopage_configuration?.videopageActionableShopify
                  ?.style?.border
                  ? videopage_configuration?.videopageActionableShopify?.style
                      ?.border
                  : "none",
              },
              event:
                videopage_configuration?.videopageActionableShopify?.event ||
                "atc",
              action_type:
                videopage_configuration?.videopageActionableShopify
                  ?.action_type || "button",
              layout:
                videopage_configuration?.videopageActionableShopify?.layout ||
                "checkout-shopping",
              actionable: {
                checkout: {
                  display:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.checkout?.display != null
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.checkout?.display
                      : true,
                  action_type:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.checkout?.action_type || "button",
                  event: "checkout",
                  name:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.checkout?.name || "Checkout",
                  style: {
                    font_color:
                      videopage_configuration?.videopageActionableShopify
                        ?.actionable?.checkout?.style?.font_color || "#000000",
                    font_style: videopage_configuration
                      ?.videopageActionableShopify?.actionable?.checkout?.style
                      ?.font_style
                      ? videopage_configuration?.videopageActionableShopify?.actionable?.checkout?.style?.font_style.includes(
                          "italic"
                        )
                        ? "italic"
                        : videopage_configuration?.videopageActionableShopify
                            ?.actionable?.checkout?.style?.font_style
                      : "normal",
                    bg_color:
                      videopage_configuration?.videopageActionableShopify
                        ?.actionable?.checkout?.style?.bg_color || "#ECD4D4",
                    font_weight: videopage_configuration
                      ?.videopageActionableShopify?.actionable?.checkout?.style
                      ?.font_weight
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.checkout?.style?.font_weight
                      : "400",
                    borderRadius: videopage_configuration
                      ?.videopageActionableShopify?.style?.borderRadius
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.checkout?.style?.borderRadius
                      : "6px",
                    border: videopage_configuration?.videopageActionableShopify
                      ?.style?.border
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.checkout?.style?.border
                      : "none",
                  },
                },
                shopping: {
                  display:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.shopping?.display != null
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.shopping?.display
                      : true,
                  action_type:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.shopping?.action_type || "button",
                  event: "checkout",
                  name:
                    videopage_configuration?.videopageActionableShopify
                      ?.actionable?.shopping?.name || "Checkout",
                  style: {
                    font_color:
                      videopage_configuration?.videopageActionableShopify
                        ?.actionable?.shopping?.style?.font_color || "#000000",
                    font_style: videopage_configuration
                      ?.videopageActionableShopify?.actionable?.shopping?.style
                      ?.font_style
                      ? videopage_configuration?.videopageActionableShopify?.actionable?.shopping?.style?.font_style.includes(
                          "italic"
                        )
                        ? "italic"
                        : videopage_configuration?.videopageActionableShopify
                            ?.actionable?.shopping?.style?.font_style
                      : "normal",
                    bg_color:
                      videopage_configuration?.videopageActionableShopify
                        ?.actionable?.shopping?.style?.bg_color || "#ECD4D4",
                    font_weight: videopage_configuration
                      ?.videopageActionableShopify?.actionable?.shopping?.style
                      ?.font_weight
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.shopping?.style?.font_weight
                      : "400",
                    borderRadius: videopage_configuration
                      ?.videopageActionableShopify?.style?.borderRadius
                      ? videopage_configuration?.videopageActionableShopify
                          ?.style?.borderRadius
                      : "6px",
                    border: videopage_configuration?.videopageActionableShopify
                      ?.actionable?.shopping?.style?.border
                      ? videopage_configuration?.videopageActionableShopify
                          ?.actionable?.shopping?.style?.border
                      : "none",
                  },
                },
              },
            },
          }
        : {
            atc: {
              display:
                videopage_configuration?.videopageActionableNonShopify
                  ?.display != null
                  ? videopage_configuration?.videopageActionableNonShopify
                      ?.display
                  : true,
              name:
                videopage_configuration?.videopageActionableNonShopify?.name ||
                "Add To Cart",
              style: {
                font_color:
                  videopage_configuration?.videopageActionableNonShopify?.style
                    ?.font_color || "#000000",
                font_style: videopage_configuration
                  ?.videopageActionableNonShopify?.style?.font_style
                  ? videopage_configuration?.videopageActionableNonShopify?.style?.font_style.includes(
                      "italic"
                    )
                    ? "italic"
                    : videopage_configuration?.videopageActionableNonShopify
                        ?.style?.font_styleL
                  : "normal",
                bg_color:
                  videopage_configuration?.videopageActionableNonShopify?.style
                    ?.bg_color || "#ECD4D4",
                font_weight: videopage_configuration
                  ?.videopageActionableNonShopify?.style?.font_weight
                  ? videopage_configuration?.videopageActionableNonShopify
                      ?.style?.font_weight
                  : "400",
                borderRadius: videopage_configuration
                  ?.videopageActionableNonShopify?.style?.borderRadius
                  ? videopage_configuration?.videopageActionableNonShopify
                      ?.style?.borderRadius
                  : "6px",
                border: videopage_configuration?.videopageActionableNonShopify
                  ?.style?.border
                  ? videopage_configuration?.videopageActionableNonShopify
                      ?.style?.border
                  : "none",
              },
              event: "pdp",
              action_type:
                videopage_configuration?.videopageActionableNonShopify
                  ?.action_type || "button",
            },
          },

    atc: {
      primary: {
        name:
          videopage_configuration?.videopagePrimaryATC?.text || "Add to cart",
        style: {
          font_weight: videopage_configuration?.videopagePrimaryATC?.style
            ?.font_weight
            ? videopage_configuration?.videopagePrimaryATC?.style?.font_weight
            : "400",
          font_color: videopage_configuration?.videopagePrimaryATC?.style
            ?.font_color
            ? videopage_configuration?.videopagePrimaryATC?.style?.font_color
            : "#000",
          bg_color: videopage_configuration?.videopagePrimaryATC?.style
            ?.bg_color
            ? videopage_configuration?.videopagePrimaryATC?.style?.bg_color
            : "#fff",
          borderRadius: videopage_configuration?.videopagePrimaryATC?.style
            ?.borderRadius
            ? videopage_configuration?.videopagePrimaryATC?.style?.borderRadius
            : "6px",
          border: videopage_configuration?.videopagePrimaryATC?.style?.border
            ? videopage_configuration?.videopagePrimaryATC?.style?.border
            : "none",
        },
      },
      secondary: {
        name:
          videopage_configuration?.videopageSecondryATC?.text || "More Info",
        style: {
          font_weight: videopage_configuration?.videopageSecondryATC?.style
            ?.font_weight
            ? videopage_configuration?.videopageSecondryATC?.style?.font_weight
            : "400",
          font_color: videopage_configuration?.videopageSecondryATC?.style
            ?.font_color
            ? videopage_configuration?.videopageSecondryATC?.style?.font_color
            : "#000",
          bg_color: videopage_configuration?.videopageSecondryATC?.style
            ?.bg_color
            ? videopage_configuration?.videopageSecondryATC?.style?.bg_color
            : "#fff",
          borderRadius: videopage_configuration?.videopageSecondryATC?.style
            ?.borderRadius
            ? videopage_configuration?.videopagePrimaryATC?.style?.borderRadius
            : "6px",
          border: videopage_configuration?.videopageSecondryATC?.style?.border
            ? videopage_configuration?.videopageSecondryATC?.style?.border
            : "none",
        },
      },
    },
    product: {
      display:
        videopage_configuration?.videopageProduct?.display != null
          ? videopage_configuration?.videopageProduct?.display
          : true,
      product_layout: {
        layout_size: videopage_configuration?.productLayoutSize
          ? videopage_configuration?.productLayoutSize
          : "M",
      },
      type: videopage_configuration?.videopageProduct?.type || "single",
      style: {
        bg_color:
          videopage_configuration?.videopageProduct?.style?.bg_color ||
          "#000000",
      },
      image: {
        display:
          videopage_configuration?.videopageProduct?.image?.display != null
            ? videopage_configuration?.videopageProduct?.image?.display
            : true,
        type:
          videopage_configuration?.videopageProduct?.image?.type || "circle",
        style: {
          height: videopage_configuration?.videopageProduct?.image?.style
            ?.height
            ? Number(
                videopage_configuration?.videopageProduct?.image?.style?.height.replace(
                  "px",
                  ""
                )
              )
            : 32,
        },
      },
      name: {
        display:
          videopage_configuration?.videopageProduct?.name?.display != null
            ? videopage_configuration?.videopageProduct?.name?.display
            : true,
        style: {
          font_color:
            videopage_configuration?.videopageProduct?.name?.style
              ?.font_color || "#000000",
          font_style: videopage_configuration?.videopageProduct?.name?.style
            ?.font_style
            ? videopage_configuration?.videopageProduct?.name?.style?.font_style.includes(
                "italic"
              )
              ? "italic"
              : videopage_configuration?.videopageProduct?.name?.style
                  ?.font_style
            : "normal",
          font_weight: videopage_configuration?.videopageProduct?.name?.style
            ?.font_weight
            ? videopage_configuration?.videopageProduct?.name?.style
                ?.font_weight
            : "400",
        },
      },
      description: {
        display:
          videopage_configuration?.videopageProduct?.description?.display !=
          null
            ? videopage_configuration?.videopageProduct?.description?.display
            : false,
        style: {
          font_color:
            videopage_configuration?.videopageProduct?.description?.style
              ?.font_color || "#000000",
          font_style: videopage_configuration?.videopageProduct?.description
            ?.style?.font_style
            ? videopage_configuration?.videopageProduct?.description?.style?.font_style.includes(
                "italic"
              )
              ? "italic"
              : videopage_configuration?.videopageProduct?.description?.style
                  ?.font_style
            : "normal",
        },
      },
      price: {
        display:
          videopage_configuration?.videopagePrice?.display != null
            ? videopage_configuration?.videopagePrice?.display
            : true,
        symbolText: videopage_configuration?.videopagePrice?.text || "INR",
        format: videopage_configuration?.videopagePrice?.format || "integer",
        prefix:
          videopage_configuration?.videopagePrice?.prefix != null
            ? videopage_configuration?.videopagePrice?.prefix
            : true,
        original: {
          display:
            videopage_configuration?.videopagePrice?.original?.display != null
              ? videopage_configuration?.videopagePrice?.original?.display
              : true,
          style: {
            font_color:
              videopage_configuration?.videopagePrice?.original?.style
                ?.font_color || "#000000",
            font_style: videopage_configuration?.videopagePrice?.original?.style
              ?.font_style
              ? videopage_configuration?.videopagePrice?.original?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : videopage_configuration?.videopagePrice?.original?.style
                    ?.font_style
              : "normal",
            font_weight: videopage_configuration?.videopagePrice?.original
              ?.style?.font_weight
              ? videopage_configuration?.videopagePrice?.original?.style
                  ?.font_weight
              : "400",
          },
        },
        offer: {
          display:
            videopage_configuration?.videopagePrice?.offer?.display != null
              ? videopage_configuration?.videopagePrice?.offer?.display
              : true,
          style: {
            font_color:
              videopage_configuration?.videopagePrice?.offer?.style
                ?.font_color || "#000000",
            font_style: videopage_configuration?.videopagePrice?.offer?.style
              ?.font_style
              ? videopage_configuration?.videopagePrice?.offer?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : videopage_configuration?.videopagePrice?.offer?.style
                    ?.font_style
              : "normal",
            font_weight: videopage_configuration?.videopagePrice?.offer?.style
              ?.font_weight
              ? videopage_configuration?.videopagePrice?.offer?.style
                  ?.font_weight
              : "400",
          },
        },
        discount: {
          display:
            videopage_configuration?.videopagePrice?.discount?.display != null
              ? videopage_configuration?.videopagePrice?.discount?.display
              : true,
          style: {
            font_color:
              videopage_configuration?.videopagePrice?.discount?.style
                ?.font_color || "#000000",
            font_style: videopage_configuration?.videopagePrice?.discount?.style
              ?.font_style
              ? videopage_configuration?.videopagePrice?.discount?.style?.font_style.includes(
                  "italic"
                )
                ? "italic"
                : videopage_configuration?.videopagePrice?.discount?.style
                    ?.font_style
              : "normal",
            font_weight: videopage_configuration?.videopagePrice?.discount
              ?.style?.font_weight
              ? videopage_configuration?.videopagePrice?.discount?.style
                  ?.font_weight
              : "400",
          },
        },
      },
      more_info: {
        display:
          videoPageData?.product?.more_info?.display != null
            ? videoPageData?.product?.more_info?.display
            : true,
        event: "pdp",
      },
    },
    glass_theme:
      videoPageData?.glass_theme != null ? videoPageData?.glass_theme : false,

    glass_theme_atc: {
      primary: {
        text:
          videopage_configuration?.videPagePrimaryGlassATC?.text != null
            ? videopage_configuration?.videPagePrimaryGlassATC?.text
            : "Add To Cart",
        style: {
          font_color:
            videopage_configuration?.videPagePrimaryGlassATC?.style
              ?.font_color != null
              ? videopage_configuration?.videPagePrimaryGlassATC?.style
                  ?.font_color
              : "#000000",
          font_weight:
            videopage_configuration?.videPagePrimaryGlassATC?.style
              ?.font_weight != null
              ? videopage_configuration?.videPagePrimaryGlassATC?.style
                  ?.font_weight
              : "400",
          bg_color:
            videopage_configuration?.videPagePrimaryGlassATC?.style?.bg_color !=
            null
              ? videopage_configuration?.videPagePrimaryGlassATC?.style
                  ?.bg_color
              : "#ffffff",
          borderRadius: videopage_configuration?.videPagePrimaryGlassATC?.style
            ?.borderRadius
            ? videopage_configuration?.videPagePrimaryGlassATC?.style
                ?.borderRadius
            : "6px",
          border: videopage_configuration?.videPagePrimaryGlassATC?.style
            ?.border
            ? videopage_configuration?.videPagePrimaryGlassATC?.style?.border
            : "none",
        },
      },
      secondary: {
        text:
          videopage_configuration?.videPageSecondaryGlassATC?.text != null
            ? videopage_configuration?.videPageSecondaryGlassATC?.text
            : "Buy Now",
        style: {
          font_color:
            videopage_configuration?.videPageSecondaryGlassATC?.style
              ?.font_color != null
              ? videopage_configuration?.videPageSecondaryGlassATC?.style
                  ?.font_color
              : "#000000",
          font_weight:
            videopage_configuration?.videPageSecondaryGlassATC?.style
              ?.font_weight != null
              ? videopage_configuration?.videPageSecondaryGlassATC?.style
                  ?.font_weight
              : "400",
          bg_color:
            videopage_configuration?.videPageSecondaryGlassATC?.style
              ?.bg_color != null
              ? videopage_configuration?.videPageSecondaryGlassATC?.style
                  ?.bg_color
              : "#ffffff",
          borderRadius: videopage_configuration?.videPageSecondaryGlassATC
            ?.style?.borderRadius
            ? videopage_configuration?.videPageSecondaryGlassATC?.style
                ?.borderRadius
            : "6px",
          border: videopage_configuration?.videPageSecondaryGlassATC?.style
            ?.border
            ? videopage_configuration?.videPageSecondaryGlassATC?.style?.border
            : "none",
        },
      },
    },
    checkout_cta: {
      text: videopage_configuration?.videoPageCheckoutCTA?.text || "Buy Now",
      style: {
        font_color:
          videopage_configuration?.videoPageCheckoutCTA?.style?.font_color ||
          "#ffffff",
        bg_color:
          videopage_configuration?.videoPageCheckoutCTA?.style?.bg_color ||
          "#000000",
        font_weight:
          videopage_configuration?.videoPageCheckoutCTA?.style?.font_weight !=
          null
            ? videopage_configuration?.videoPageCheckoutCTA?.style?.font_weight
            : "500",
        borderRadius: videopage_configuration?.videoPageCheckoutCTA?.style
          ?.borderRadius
          ? videopage_configuration?.videoPageCheckoutCTA?.style?.borderRadius
          : "6px",
        border: videopage_configuration?.videoPageCheckoutCTA?.style?.border
          ? videopage_configuration?.videoPageCheckoutCTA?.style?.border
          : "none",
      },
    },
    vudio_branding: {
      display: videoPageData?.vudio_branding?.display,
      style:{
        placement: videoPageData?.vudio_branding?.style?.placement
      }
   },     
    cart_icon: videoPageData?.cart_icon,
    tags:{
      display: videoPageData?.tags?.display,
     },
  };
  return videConfigruation;
};

export const getHomePagePayload = (homepageConfiguration) => {
  const toHexStringIfNotAlready = (color) => {
    if (typeof color === "string" && color.startsWith("#")) {
      return color;
    } else {
      return color?.toHexString?.();
    }
  };
  let home_page = {
    layout: "3d_scroll",
    home_page_background: {
      background_image: homepageConfiguration?.background?.background_image,
      display: homepageConfiguration?.background?.display,
    },
    actionable: {
      redirect: {
        action_type: "button",
        display: homepageConfiguration?.actionable?.redirect?.display,
        style: {
          font_color: toHexStringIfNotAlready(
            homepageConfiguration?.actionable?.redirect?.style?.font_color
          ),
          bg_color: toHexStringIfNotAlready(
            homepageConfiguration?.actionable?.redirect?.style?.bg_color
          ),
          font_style:
            homepageConfiguration?.actionable?.redirect?.style?.font_style,
          font_weight:
            homepageConfiguration?.actionable?.redirect?.style?.font_weight,
          borderRadius:
            homepageConfiguration?.actionable?.redirect?.style?.borderRadius,
          border: toHexStringIfNotAlready(
            homepageConfiguration?.actionable?.redirect?.style?.border
          ),
        },
        text: homepageConfiguration?.actionable?.redirect?.text,
        event: homepageConfiguration?.actionable?.redirect?.event,
      },
    },
    header: {
      display: homepageConfiguration?.header?.display,
      text: homepageConfiguration?.header?.text,
      style: {
        font_color: toHexStringIfNotAlready(
          homepageConfiguration?.header?.style?.font_color
        ),
        font_style: homepageConfiguration?.header?.style?.font_style,
        font_weight: homepageConfiguration?.header?.style?.font_weight,
        font_size: homepageConfiguration?.header?.style?.font_size,
      },
    },
    views: {
      display: homepageConfiguration?.views?.display,
      icon: homepageConfiguration?.views?.icon,
      style: {
        placement: homepageConfiguration?.views?.style?.placement,
        bg_color: toHexStringIfNotAlready(
          homepageConfiguration?.views?.style?.bg_color
        ),
      },
    },
    discount: {
      display: homepageConfiguration?.discount?.display,
      style: {
        bg_color: toHexStringIfNotAlready(
          homepageConfiguration?.discount?.style?.bg_color
        ),
        font_color: toHexStringIfNotAlready(
          homepageConfiguration?.discount?.style?.font_color
        ),
        placement: homepageConfiguration?.discount?.style?.placement,
        font_weight: homepageConfiguration?.discount?.style?.font_weight,
      },
      text: homepageConfiguration?.discount?.text,
    },
    mute_unmute: {
      display: homepageConfiguration?.mute_unmute?.display,
    },
    play_pause: {
      display: homepageConfiguration?.play_pause?.display,
    },
    product: {
      display: homepageConfiguration?.name_card?.display
        ? false
        : homepageConfiguration?.product?.display,
      type: homepageConfiguration?.product?.type,
      layout: homepageConfiguration?.product?.layout,
      placement: homepageConfiguration?.product?.placement,
      image: {
        display: homepageConfiguration?.product?.image?.display,
        type: homepageConfiguration?.product?.image?.type,
        style: {
          height:
            String(homepageConfiguration?.product?.image?.style?.height) + "px",
          width:
            String(homepageConfiguration?.product?.image?.style?.height) + "px",
        },
      },
      name: {
        display: homepageConfiguration?.product?.name?.display,
        style: {
          font_color: toHexStringIfNotAlready(
            homepageConfiguration?.product?.name?.style?.font_color
          ),
          font_style: homepageConfiguration?.product?.name?.style?.font_style,
          font_weight: homepageConfiguration?.product?.name?.style?.font_weight,
        },
      },
      description:
        website == "others"
          ? {
              display: homepageConfiguration?.product?.description?.display,
              style: {
                font_color: toHexStringIfNotAlready(
                  homepageConfiguration?.product?.description?.style?.font_color
                ),
                font_style:
                  homepageConfiguration?.product?.description?.style
                    ?.font_style,
                font_weight:
                  homepageConfiguration?.product?.description?.style
                    ?.font_weight,
              },
            }
          : {
              display: false,
              style: {
                font_color: "#000000",
                font_style: "bold",
              },
            },
      price: {
        display: homepageConfiguration?.product?.price?.display,
        text: homepageConfiguration?.product?.price?.symbolText,
        format: homepageConfiguration?.product?.price?.format,
        prefix: homepageConfiguration?.product?.price?.prefix,
        original: {
          display: homepageConfiguration?.product?.price?.original?.display,
          style: {
            font_color: toHexStringIfNotAlready(
              homepageConfiguration?.product?.price?.original?.style?.font_color
            ),
            font_style:
              homepageConfiguration?.product?.price?.original?.style
                ?.font_style,
            font_weight:
              homepageConfiguration?.product?.price?.original?.style
                ?.font_weight,
          },
        },
        offer: {
          display: homepageConfiguration?.product?.price?.offer?.display,
          style: {
            font_color: toHexStringIfNotAlready(
              homepageConfiguration?.product?.price?.offer?.style?.font_color
            ),
            font_style:
              homepageConfiguration?.product?.price?.offer?.style?.font_style,
            font_weight:
              homepageConfiguration?.product?.price?.offer?.style?.font_weight,
          },
        },
        discount: {
          display:
            homepageConfiguration?.product?.price?.discount?.display != null
              ? homepageConfiguration?.product?.price?.discount?.display
              : true,
          style: {
            font_color: toHexStringIfNotAlready(
              homepageConfiguration?.product?.price?.discount?.style?.font_color
            ),
            font_style:
              homepageConfiguration?.product?.price?.discount?.style
                ?.font_style || "normal",
            font_weight:
              homepageConfiguration?.product?.price?.discount?.style
                ?.font_weight,
          },
        },
      },
    },
    vudio_branding: {
      display: homepageConfiguration?.vudio_branding?.display,
      style:{
        placement: homepageConfiguration?.vudio_branding?.style?.placement
      }
   },
   
    like: homepageConfiguration?.like,
    share: homepageConfiguration?.share,
   
   view_more_sf_cta:{
    display: homepageConfiguration?.view_more_sf_cta?.display,
    text: homepageConfiguration?.view_more_sf_cta?.text,
    style: {
      font_color: toHexStringIfNotAlready(homepageConfiguration?.view_more_sf_cta?.style?.font_color),
      bg_color: toHexStringIfNotAlready(homepageConfiguration?.view_more_sf_cta?.style?.bg_color),
      font_style: homepageConfiguration?.view_more_sf_cta?.style?.font_style,
      font_weight: homepageConfiguration?.view_more_sf_cta?.style?.font_weight,
    },    
  },
    tabs_config:{
    font_color: toHexStringIfNotAlready(homepageConfiguration?.tabs_config?.font_color),
  }     
  };
  return home_page;
};

export const getPdpPagePayload = (pdp_configuration) => {
  let pdp_page = {
    style: {
      height: pdp_configuration?.show_sf_name
        ? "inherit"
        : String(pdp_configuration?.height) + "px",
      width: String(pdp_configuration?.width) + "px",
      font_size: String(pdp_configuration?.font_size) + "px",
      name_card_height: "4vh",
      font_weight: pdp_configuration?.font_weight,
    },
    show_branding: pdp_configuration?.show_branding,
    show_sf_name: pdp_configuration?.show_sf_name,
  };
  return pdp_page;
};

export const storyConfiguration = {
  borderColor: {
    primaryColor: "#FF406C",
  },
  is_playback_image: true,
  name_color: "#000",
  font_weight: "600",
  cta_text_color: "#ffffff",
  cta_color: "#FF406C",
  cta_text: "Shop Now",
  font_style: "native",
  story_size: 100,
  gap: 15,
  padding: 5,
  video_title_view: true,
};

export const handleStoryConfiguration = (sfConfigData) => {
  console.log("SFFF STORYY CONFIGGG", sfConfigData);
  let story_configuration = {
    borderColor: {
      primaryColor: sfConfigData?.story_home_page?.border_color,
    },
    is_playback_image: sfConfigData?.story_home_page?.is_playback_image,
    name_color: sfConfigData?.story_home_page?.name_color || "#000",
    font_weight: sfConfigData?.story_home_page?.font_weight || "600",
    cta_text_color:
      sfConfigData?.story_home_page?.cta_button_text_color || "#ffffff",
    cta_color: sfConfigData?.story_home_page?.cta_button_color || "#FF406C",
    cta_text: sfConfigData?.story_home_page?.cta_button_text || "Shop Now",
    font_style: sfConfigData?.story_home_page?.font_style || "native",
    story_size: sfConfigData?.story_home_page?.story_size
      ? Number(sfConfigData?.story_home_page?.story_size.replace("px", ""))
      : 80,
    gap: sfConfigData?.story_home_page?.gap
      ? Number(sfConfigData?.story_home_page?.gap.replace("px", ""))
      : 15,
    padding: sfConfigData?.story_home_page?.padding
      ? Number(sfConfigData?.story_home_page?.padding.replace("%", ""))
      : 5,
    video_title_view:
      sfConfigData?.story_home_page?.video_title_view == true
        ? sfConfigData?.story_home_page?.video_title_view
        : false,
  };

  return story_configuration;
};

export const handlePopupWidgetConfiguration = (popupConfigData) => {
  let popup_configuration = {
    button_color: popupConfigData?.button_color || "#FF0000",
    continue_shopping_color:
      popupConfigData?.continue_shopping_color || "#000000",
    continue_shopping_text:
      popupConfigData?.continue_shopping_text || "Continue Shopping",
    continue_shopping_text_color:
      popupConfigData?.continue_shopping_text_color || "#ffffff",
    desc_color: popupConfigData?.desc_color || "#000000",
    description_background_color:
      popupConfigData?.description_background_color || "#ffffff",
    header_background_color:
      popupConfigData?.header_background_color || "#ffffff",
    heading_color: popupConfigData?.heading_color || "#000000",
    show_description_background:
      popupConfigData?.show_description_background || false,
    show_header_background: popupConfigData?.show_header_background || false,
    show_sound_icon: popupConfigData?.show_sound_icon || true,
    submission_text_color: popupConfigData?.submission_text_color || "#000000",
    text: popupConfigData?.text || "Submit",
    text_color: popupConfigData?.text_color || "#FFFFFF",
    video_layout: popupConfigData?.video_layout || "1",
  };

  return popup_configuration;
};
